interface ErrorInput {
  message: string;
  statusCode?: number;
  response?: { status?: number };
  isAxiosError?: boolean;
}

class Error {
  message = '';

  statusCode: number | undefined;

  isAxiosError: boolean | undefined;

  constructor(error: ErrorInput) {
    this.message = error.message;
    this.statusCode =
      error.statusCode || (error.response && error.response.status);
    this.isAxiosError = error.isAxiosError;
  }

  isConnectionError(): boolean {
    return (this.statusCode !== undefined && this.statusCode >= 500) || (!!this.isAxiosError && !this.statusCode);
  }

  isAuthenticationError(): boolean {
    return this.statusCode !== undefined && [401, 403].includes(this.statusCode);
  }

  toString(): string {
    return JSON.stringify({
      message: this.message,
      statusCode: this.statusCode,
    });
  }
}

export default Error;
